<div class="mb-5">
  <p-panel header="State Physical Financial Target" [toggleable]="true" [collapsed]="true">
    <div class="physical-fin-target card">
      <div class="">
        <div class="grid p-fluid mt-3">
          <div class="field col-12 md:col-6">
            <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3">
              {{'Insert State Physical Financial Target'| translate}}</h5>
          </div>

          <div class="field col-12 md:col-6 justify-end">
            <div>
              <p-fileUpload accept=".xlsx" #fileUpload [customUpload]="true"
                (uploadHandler)="onUploadStateFinDetails($event, 'statePhyicalFinanceData', fileUpload)" name="myfile[]"
                mode="basic" [maxFileSize]="500000000" chooseLabel="{{'Upload Excel' | translate}}" [auto]="true">
              </p-fileUpload>
              <a href="../../../../assets/smaple excel/state_fin_target.xlsx" target="_blank"
              class="cursorPtr" style="color:rgb(95, 172, 228); font-size: '0.8rem'; font-weight: bold; justify-content: end;">
              Download Sample Excel</a>
            </div>
            <button *ngIf="statePhyFinanceData?.length" pButton pRipple type="button" icon="pi pi-trash"
                pTooltip="{{'DELETE_FILE' | translate}}"
                class="p-button-rounded p-button-danger p-button-text" (click)="clearStateUploadData()"></button>
            </div>
        </div>
        
        
        <!-- <div class="flex align-items-center justify-content-center col-12 md:col-6">
          <p-fileUpload accept=".xlsx" #fileUpload [customUpload]="true"
              (uploadHandler)="onUploadStateFinDetails($event, 'statePhyicalFinanceData', fileUpload)" name="myfile[]"
              mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
          </p-fileUpload>
          <button *ngIf="statePhyFinanceData?.length" pButton pRipple type="button"
              label="{{'VIEW_DOC' | translate}}" class="p-button-text"></button>
          <button *ngIf="statePhyFinanceData?.length" pButton pRipple type="button" icon="pi pi-trash"
              pTooltip="{{'DELETE_FILE' | translate}}"
              class="p-button-rounded p-button-danger p-button-text" (click)="clearStateUploadData()"></button>
        </div> -->

        <form [formGroup]="statePhyFinanceForm" (ngSubmit)="addStatePhyFinanceData()">
          <div class="grid p-fluid mt-3">
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_FinancialYear_ID" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_FinancialYear_ID"
                  [ngClass]="{ 'ng-invalid ng-dirty': statePhyFinanceForm.controls['I_FinancialYear_ID'].invalid && statePhyFinanceForm.controls['I_FinancialYear_ID'].touched }" />
                <div
                  *ngIf="statePhyFinanceForm.controls['I_FinancialYear_ID'].invalid && statePhyFinanceForm.controls['I_FinancialYear_ID'].touched"
                  class="invalid-feedback">
                  <div *ngIf="statePhyFinanceForm.controls['I_FinancialYear_ID'].errors.required">
                    {{'FINANCIAL_YEAR_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="I_FinancialYear_ID">{{'FINANCIAL_YEAR'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_State_Code" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_State_Code"
                  [ngClass]="{ 'ng-invalid ng-dirty': statePhyFinanceForm.controls['I_State_Code'].invalid && statePhyFinanceForm.controls['I_State_Code'].touched }" />
                <div
                  *ngIf="statePhyFinanceForm.controls['I_State_Code'].invalid && statePhyFinanceForm.controls['I_State_Code'].touched"
                  class="invalid-feedback">
                  <div *ngIf="statePhyFinanceForm.controls['I_State_Code'].errors.required">{{'State Code is required'|
                    translate}}</div>
                </div>
                <label for="I_State_Code">{{'State Code'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_Activity_ID" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_Activity_ID"
                  [ngClass]="{ 'ng-invalid ng-dirty': statePhyFinanceForm.controls['I_Activity_ID'].invalid && statePhyFinanceForm.controls['I_Activity_ID'].touched }" />
                <div
                  *ngIf="statePhyFinanceForm.controls['I_Activity_ID'].invalid && statePhyFinanceForm.controls['I_Activity_ID'].touched"
                  class="invalid-feedback">
                  <div *ngIf="statePhyFinanceForm.controls['I_Activity_ID'].errors.required">{{'Activity Id is required'|
                    translate}}</div>
                </div>
                <label for="I_Activity_ID">{{'Activity Id'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_PT" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_PT"
                  [ngClass]="{ 'ng-invalid ng-dirty': statePhyFinanceForm.controls['I_PT'].invalid && statePhyFinanceForm.controls['I_PT'].touched }" />
                <div *ngIf="statePhyFinanceForm.controls['I_PT'].invalid && statePhyFinanceForm.controls['I_PT'].touched"
                  class="invalid-feedback">
                  <div *ngIf="statePhyFinanceForm.controls['I_PT'].errors.required">{{'PT is required and must be a positive
                    number'| translate}}</div>
                </div>
                <label for="I_PT">{{'PT'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_FT" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_FT"
                  [ngClass]="{ 'ng-invalid ng-dirty': statePhyFinanceForm.controls['I_FT'].invalid && statePhyFinanceForm.controls['I_FT'].touched }" />
                <div *ngIf="statePhyFinanceForm.controls['I_FT'].invalid && statePhyFinanceForm.controls['I_FT'].touched"
                  class="invalid-feedback">
                  <div *ngIf="statePhyFinanceForm.controls['I_FT'].errors.required">{{'FT is required and must be a positive
                    number'| translate}}</div>
                </div>
                <label for="I_FT">{{'FT'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <button [disabled]="statePhyFinanceForm.controls.invalid" pButton pRipple type="submit"
                label="{{'ADD' | translate}}" class="p-button-secondary mt-2 ml-5"
                style="width: 90px; height: 32px; align-items: center;">
              </button>
            </div>
          </div>
    
          <!-- <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-2">
              <label for="I_FinancialYear_ID">{{'Financial Year' | translate}}</label>
              <div class="grid-item">
                <input pInputText type="number" formControlName="I_FinancialYear_ID" />
                <div
                  *ngIf="statePhyFinanceForm.controls['I_FinancialYear_ID'].invalid && statePhyFinanceForm.controls['I_FinancialYear_ID'].touched"
                  class="p-error">
                  {{'Financial Year is required' | translate}}
                </div>
              </div>
            </div>
    
            <div class="field col-12 md:col-2">
              <label for="I_State_Code">{{'State Code' | translate}}</label>
              <div class="grid-item">
                <input pInputText type="number" formControlName="I_State_Code" />
                <div *ngIf="statePhyFinanceForm.controls['I_State_Code'].invalid && statePhyFinanceForm.controls['I_State_Code'].touched"
                  class="p-error">
                  {{'State Code is required' | translate}}
                </div>
              </div>
            </div>
    
            <div class="field col-12 md:col-2">
              <label for="I_Activity_ID">{{'Activity ID' | translate}}</label>
              <div class="grid-item">
                <input pInputText type="number" formControlName="I_Activity_ID" />
                <div *ngIf="statePhyFinanceForm.controls['I_Activity_ID'].invalid && statePhyFinanceForm.controls['I_Activity_ID'].touched"
                  class="p-error">
                  {{'Activity ID is required' | translate}}
                </div>
              </div>
            </div>
    
            <div class="field col-12 md:col-2">
              <label for="I_PT">{{'PT' | translate}}</label>
              <div class="grid-item">
                <input pInputText type="number" step="0.01" formControlName="I_PT" />
                <div *ngIf="statePhyFinanceForm.controls['I_PT'].invalid && statePhyFinanceForm.controls['I_PT'].touched" class="p-error">
                  {{'PT is required and must be a positive number' | translate}}
                </div>
              </div>
            </div>
    
            <div class="field col-12 md:col-2">
              <label for="I_FT">{{'FT' | translate}}</label>
              <div class="grid-item">
                <input pInputText type="number" step="0.01" formControlName="I_FT" />
                <div *ngIf="statePhyFinanceForm.controls['I_FT'].invalid && statePhyFinanceForm.controls['I_FT'].touched" class="p-error">
                  {{'FT is required and must be a positive number' | translate}}
                </div>
              </div>
            </div>
    
            <div class="field col-12 md:col-2 mt-4">
              <button [disabled]="statePhyFinanceForm.controls.invalid" pButton pRipple type="submit" label="{{'ADD' | translate}}"
                class="p-button-secondary mt-2 ml-5" style="width: 90px; height: 32px; align-items: center;">
              </button>
            </div>
          </div> -->
        </form>
    
        <div *ngIf="statePhyFinanceData.length > 0" class="dashboardTable" style="margin: 5px;">
          <p-table [value]="statePhyFinanceData" [rows]="10" [paginator]="false" responsiveLayout="scroll" [rowHover]="true"
            [showCurrentPageReport]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'Financial Year' | translate}}</th>
                <th>{{'State Code' | translate}}</th>
                <th>{{'Activity ID' | translate}}</th>
                <th>{{'PT' | translate}}</th>
                <th>{{'FT' | translate}}</th>
                <th>{{'Action' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-target let-rowIndex="rowIndex">
              <tr>
                <td>{{target.I_FinancialYear_ID}}</td>
                <td>{{target.I_State_Code}}</td>
                <td>{{target.I_Activity_ID}}</td>
                <td>{{target.I_PT}}</td>
                <td>{{target.I_FT}}</td>
                <td>
                  <button pButton pRipple type="button" icon="pi pi-times" (click)="deleteStatePhyTarget(rowIndex)"
                    class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
    
        <div *ngIf="statePhyFinanceData.length > 0" class="button-container-submit">
          <button pButton pRipple (click)="onSubmitStatePhyTarDate()" label="{{'SUBMIT' | translate}}"
            class="p-button-success" style="width: 100px; height: 32px; align-items: center;">
          </button>
        </div>
      </div>
    </div>
    
    <div class="get-physical-fin-target card">
      <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Get State Physical
        Financial Target' |
        translate }}</p>
      <div class="p-fluid p-formgrid grid added-farmer-data justify-content-center">
        <div class="field col-12 md:col-4">
          <!-- <label></label> -->
          <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
            <button (click)="onClickGetStateTarData()" pButton pRipple label="{{ 'Get State Financial Data' | translate }}"
              class="p-button-success"></button>
          </div>
        </div>
      </div>
    
      <div *ngIf="getStatePhyFinanceData.length == 0 && showStateFinStatus">
        <p [style]="{'color': 'red', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Data Not Found'}}</p>
      </div>
    
      <div class="dashboardTable" *ngIf="getStatePhyFinanceData.length > 0">
        <!-- <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Added Farmer
          Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}} {{
          agreementNoToGetData?.AgreementNo }}</p> -->
        <p-table #stateTarDataTable [value]="getStatePhyFinanceData" [rows]="10" [paginator]="true" [globalFilterFields]="[
              'I_FinancialYear_ID',
              'I_State_Code',
              'I_Activity_ID',
              'I_FT',
              'I_PT',
              ]" [rowHover]="true" dataKey="aadharNo"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-end">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                  (input)="stateTarDataTable.filterGlobal($any($event.target).value, 'contains')"
                  placeholder="{{'SEARCH'| translate}}" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'FINANCIAL_YEAR'| translate}}</th>
              <th>{{'State Code'| translate}}</th>
              <th>{{'Activity Id'| translate}}</th>
              <th>{{'PT'| translate}}</th>
              <th>{{'FT'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{product?.I_FinancialYear_ID}}</td>
              <td>{{product?.I_State_Code}}</td>
              <td>{{product?.I_Activity_ID}}</td>
              <td>{{product?.I_FT}}</td>
              <td>{{product?.I_PT}}</td>
            </tr>
          </ng-template>
        </p-table>
    
        <div *ngIf="getStatePhyFinanceData.length > 0" class="button-container-submit">
          <button pButton pRipple (click)="onSubmitStateFinData()" label="{{'SUBMIT' | translate}}" class="p-button-success"
              style="width: 100px; height: 32px; align-items: center;">
          </button>
        </div>
      </div>
    </div>
  </p-panel>
</div>

<div class="mb-5">
  <p-panel header="District Physical Financial Target" [toggleable]="true" [collapsed]="true">

    <div class="district-fin-target card">
      <div class="" style="margin-top: 20px;">
        <div class="grid p-fluid mt-3">
          <div class="field col-12 md:col-6">
            <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3">
              {{'Insert District Physical Financial Target'| translate}}</h5>
          </div>

          <div class="field col-12 md:col-6 justify-end">
            <div>
              <p-fileUpload accept=".xlsx" #fileUpload [customUpload]="true"
                (uploadHandler)="onUploadDistrictFinDetails($event, 'districtPhyicalFinanceData', fileUpload)" name="myfile[]"
                mode="basic" [maxFileSize]="500000000" chooseLabel="{{'Upload Excel' | translate}}" [auto]="true">
              </p-fileUpload>
              <a href="../../../../assets/smaple excel/district_fin_target.xlsx" target="_blank"
              class="cursorPtr" style="color:rgb(95, 172, 228); font-size: '0.8rem'; font-weight: bold; justify-content: end;">
              Download Sample Excel</a>
            </div>
            <button *ngIf="districtPhyFinanceData?.length" pButton pRipple type="button" icon="pi pi-trash"
                pTooltip="{{'DELETE_FILE' | translate}}"
                class="p-button-rounded p-button-danger p-button-text" (click)="clearDistrictUploadData()"></button>
            </div>
        </div>

        <form [formGroup]="districtPhyFinanceForm" (ngSubmit)="addDistPhyFinanceData()">
          <div class="grid p-fluid mt-3">
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_FinancialYear_ID" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_FinancialYear_ID"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_FinancialYear_ID'].invalid && districtPhyFinanceForm.controls['I_FinancialYear_ID'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_FinancialYear_ID'].invalid && districtPhyFinanceForm.controls['I_FinancialYear_ID'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_FinancialYear_ID'].errors.required">
                    {{'FINANCIAL_YEAR_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="I_FinancialYear_ID">{{'FINANCIAL_YEAR'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_State_Code" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_State_Code"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_State_Code'].invalid && districtPhyFinanceForm.controls['I_State_Code'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_State_Code'].invalid && districtPhyFinanceForm.controls['I_State_Code'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_State_Code'].errors.required">{{'State Code is
                    required'|
                    translate}}</div>
                </div>
                <label for="I_State_Code">{{'State Code'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_District_Code" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_District_Code"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_District_Code'].invalid && districtPhyFinanceForm.controls['I_District_Code'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_District_Code'].invalid && districtPhyFinanceForm.controls['I_District_Code'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_District_Code'].errors.required">{{'District Code is
                    required'|
                    translate}}</div>
                </div>
                <label for="I_District_Code">{{'District Code'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_Activity_ID" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_Activity_ID"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_Activity_ID'].invalid && districtPhyFinanceForm.controls['I_Activity_ID'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_Activity_ID'].invalid && districtPhyFinanceForm.controls['I_Activity_ID'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_Activity_ID'].errors.required">
                    {{'Activity Id is required'| translate}}</div>
                </div>
                <label for="I_Activity_ID">{{'Activity Id'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_Crop_Code" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_Crop_Code"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_Crop_Code'].invalid && districtPhyFinanceForm.controls['I_Crop_Code'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_Crop_Code'].invalid && districtPhyFinanceForm.controls['I_Crop_Code'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_Crop_Code'].errors.required">{{'Crop Code is required.'|
                    translate}}</div>
                </div>
                <label for="I_Crop_Code">{{'Crop Code'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_PT" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_PT"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_PT'].invalid && districtPhyFinanceForm.controls['I_PT'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_PT'].invalid && districtPhyFinanceForm.controls['I_PT'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_PT'].errors.required">{{'PT is required and must be a
                    positive number'| translate}}</div>
                </div>
                <label for="I_PT">{{'PT'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <input pInputText inputId="I_FT" type="number" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="I_FT"
                  [ngClass]="{ 'ng-invalid ng-dirty': districtPhyFinanceForm.controls['I_FT'].invalid && districtPhyFinanceForm.controls['I_FT'].touched }" />
                <div
                  *ngIf="districtPhyFinanceForm.controls['I_FT'].invalid && districtPhyFinanceForm.controls['I_FT'].touched"
                  class="invalid-feedback">
                  <div *ngIf="districtPhyFinanceForm.controls['I_FT'].errors.required">{{'FT is required and must be a
                    positive number'| translate}}</div>
                </div>
                <label for="I_FT">{{'FT'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-2">
              <button [disabled]="districtPhyFinanceForm.controls.invalid" pButton pRipple type="submit"
                label="{{'ADD' | translate}}" class="p-button-secondary mt-2 ml-5"
                style="width: 90px; height: 32px; align-items: center;">
              </button>
            </div>
          </div>
    
    
          <!-- <div class="p-fluid p-formgrid grid">
        <div class="field col-12 md:col-2">
          <label for="I_FinancialYear_ID">{{'Financial Year' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" formControlName="I_FinancialYear_ID" />
            <div
              *ngIf="districtPhyFinanceForm.controls['I_FinancialYear_ID'].invalid && districtPhyFinanceForm.controls['I_FinancialYear_ID'].touched"
              class="p-error">
              {{'Financial Year is required' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <label for="I_State_Code">{{'State Code' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" formControlName="I_State_Code" />
            <div
              *ngIf="districtPhyFinanceForm.controls['I_State_Code'].invalid && districtPhyFinanceForm.controls['I_State_Code'].touched"
              class="p-error">
              {{'State Code is required' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <label for="I_District_Code">{{'District Code' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" formControlName="I_District_Code" />
            <div
              *ngIf="districtPhyFinanceForm.controls['I_District_Code'].invalid && districtPhyFinanceForm.controls['I_District_Code'].touched"
              class="p-error">
              {{'District Code is required' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <label for="I_Activity_ID">{{'Activity ID' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" formControlName="I_Activity_ID" />
            <div
              *ngIf="districtPhyFinanceForm.controls['I_Activity_ID'].invalid && districtPhyFinanceForm.controls['I_Activity_ID'].touched"
              class="p-error">
              {{'Activity ID is required' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <label for="I_Crop_Code">{{'Crop Code' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" formControlName="I_Crop_Code" />
            <div
              *ngIf="districtPhyFinanceForm.controls['I_Crop_Code'].invalid && districtPhyFinanceForm.controls['I_Crop_Code'].touched"
              class="p-error">
              {{'Crop Code is required' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <label for="I_PT">{{'PT' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" step="0.01" formControlName="I_PT" />
            <div *ngIf="districtPhyFinanceForm.controls['I_PT'].invalid && districtPhyFinanceForm.controls['I_PT'].touched"
              class="p-error">
              {{'PT is required and must be a positive number' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <label for="I_FT">{{'FT' | translate}}</label>
          <div class="grid-item">
            <input pInputText type="number" step="0.01" formControlName="I_FT" />
            <div *ngIf="districtPhyFinanceForm.controls['I_FT'].invalid && districtPhyFinanceForm.controls['I_FT'].touched"
              class="p-error">
              {{'FT is required and must be a positive number' | translate}}
            </div>
          </div>
        </div>
    
        <div class="field col-12 md:col-2">
          <button [disabled]="districtPhyFinanceForm.controls.invalid" pButton pRipple type="submit"
            label="{{'ADD' | translate}}" class="p-button-secondary mt-2 ml-5"
            style="width: 90px; height: 32px; align-items: center;">
          </button>
        </div>
      </div> -->
        </form>
    
        <div *ngIf="districtPhyFinanceData.length > 0" class="dashboardTable" style="margin: 5px;">
          <p-table [value]="districtPhyFinanceData" [rows]="10" [paginator]="false" responsiveLayout="scroll" [rowHover]="true"
            [showCurrentPageReport]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'Financial Year' | translate}}</th>
                <th>{{'State Code' | translate}}</th>
                <th>{{'District Code' | translate}}</th>
                <th>{{'Activity ID' | translate}}</th>
                <th>{{'Crop Code' | translate}}</th>
                <th>{{'PT' | translate}}</th>
                <th>{{'FT' | translate}}</th>
                <th>{{'Action' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-target let-rowIndex="rowIndex">
              <tr>
                <td>{{target.I_FinancialYear_ID}}</td>
                <td>{{target.I_State_Code}}</td>
                <td>{{target.I_District_Code}}</td>
                <td>{{target.I_Activity_ID}}</td>
                <td>{{target.I_Crop_Code}}</td>
                <td>{{target.I_PT}}</td>
                <td>{{target.I_FT}}</td>
                <td>
                  <button pButton pRipple type="button" icon="pi pi-times" (click)="deleteDistPhyTarget(rowIndex)"
                    class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
    
        <div class="button-container-submit">
          <button *ngIf="districtPhyFinanceData.length > 0" pButton pRipple (click)="onSubmitDistrictPhyTarDate()"
            label="{{'SUBMIT' | translate}}" class="p-button-success"
            style="width: 100px; height: 32px; align-items: center;">
          </button>
        </div>
      </div>
    </div>
    
    <div class="get-district-fin-target card">
      <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Get District Physical
        Financial Target' |
        translate }}</p>
      <div class="p-fluid p-formgrid grid added-farmer-data justify-content-center">
        <div class="field col-12 md:col-4">
          <!-- <label></label> -->
          <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
            <button (click)="onClickDistrictTarData()" pButton pRipple label="{{ 'Get District Financial Data' | translate }}"
              class="p-button-success"></button>
          </div>
        </div>
      </div>
    
      <div *ngIf="getDistrictPhyFinanceData.length == 0 && showDistrictFinStatus">
        <p [style]="{'color': 'red', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Data Not Found'}}</p>
      </div>
    
      <div class="dashboardTable" *ngIf="getDistrictPhyFinanceData.length > 0">
        <!-- <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Added Farmer
          Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}} {{
          agreementNoToGetData?.AgreementNo }}</p> -->
        <p-table #stateTarDataTable [value]="getDistrictPhyFinanceData" [rows]="10" [paginator]="true" [globalFilterFields]="[
              'I_FinancialYear_ID',
              'I_State_Code',
              'I_District_Code',
              'I_Activity_ID',
              'I_Crop_Code',
              'I_FT',
              'I_PT',
              ]" [rowHover]="true" dataKey="aadharNo"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-end">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                  (input)="stateTarDataTable.filterGlobal($any($event.target).value, 'contains')"
                  placeholder="{{'SEARCH'| translate}}" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'FINANCIAL_YEAR'| translate}}</th>
              <th>{{'State Code'| translate}}</th>
              <th>{{'District Code'| translate}}</th>
              <th>{{'Activity Id'| translate}}</th>
              <th>{{'Crop Id'| translate}}</th>
              <th>{{'PT'| translate}}</th>
              <th>{{'FT'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{product?.I_FinancialYear_ID}}</td>
              <td>{{product?.I_State_Code}}</td>
              <td>{{product?.I_District_Code}}</td>
              <td>{{product?.I_Activity_ID}}</td>
              <td>{{product?.I_Crop_Code}}</td>
              <td>{{product?.I_FT}}</td>
              <td>{{product?.I_PT}}</td>
            </tr>
          </ng-template>
        </p-table>
    
        <div *ngIf="getDistrictPhyFinanceData.length > 0" class="button-container-submit">
          <button pButton pRipple (click)="onSubmitDistrictFinData()" label="{{'SUBMIT' | translate}}" class="p-button-success"
              style="width: 100px; height: 32px; align-items: center;">
          </button>
        </div>
      </div>
    </div>
  </p-panel>
</div>

<div class="mb-5">
  <p-panel header="District Physical Financial Achievement" [toggleable]="true" [collapsed]="true">
    
    <div class="get-district-fin-target card">
      <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Get District Physical
        Financial Achievement' |
        translate }}</p>
      <div class="p-fluid p-formgrid grid added-farmer-data justify-content-center">
        <div class="field col-12 md:col-4">
          <!-- <label></label> -->
          <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
            <button (click)="onClickDistrictAchieveData()" pButton pRipple label="{{ 'Get Dist. Fin. Achievement Data' | translate }}"
              class="p-button-success"></button>
          </div>
        </div>
      </div>
    
      <div *ngIf="getDistrictPhyAchievementData.length == 0 && showDistrictAchievementDataStatus">
        <p [style]="{'color': 'red', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Data Not Found'}}</p>
      </div>
    
      <div class="dashboardTable" *ngIf="getDistrictPhyAchievementData.length > 0">
        <!-- <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Added Farmer
          Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}} {{
          agreementNoToGetData?.AgreementNo }}</p> -->
        <p-table #stateTarDataTable [value]="getDistrictPhyAchievementData" [rows]="10" [paginator]="true" [globalFilterFields]="[
              'I_FinancialYear_ID',
              'I_State_Code',
              'I_District_Code',
              'I_Activity_ID',
              'I_Crop_Code',
              'I_Month_ID',
              'I_FT',
              'I_PT',
              ]" [rowHover]="true" dataKey="aadharNo"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-end">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                  (input)="stateTarDataTable.filterGlobal($any($event.target).value, 'contains')"
                  placeholder="{{'SEARCH'| translate}}" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'FINANCIAL_YEAR'| translate}}</th>
              <th>{{'State Code'| translate}}</th>
              <th>{{'District Code'| translate}}</th>
              <th>{{'Activity Id'| translate}}</th>
              <th>{{'Crop Id'| translate}}</th>
              <th>{{'Month Id'| translate}}</th>
              <th>{{'PT'| translate}}</th>
              <th>{{'FT'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{product?.I_FinancialYear_ID}}</td>
              <td>{{product?.I_State_Code}}</td>
              <td>{{product?.I_District_Code}}</td>
              <td>{{product?.I_Activity_ID}}</td>
              <td>{{product?.I_Crop_Code}}</td>
              <td>{{product?.I_Month_ID}}</td>
              <td>{{product?.I_FT}}</td>
              <td>{{product?.I_PT}}</td>
            </tr>
          </ng-template>
        </p-table>
    
        <div *ngIf="getDistrictPhyAchievementData.length > 0" class="button-container-submit">
          <button pButton pRipple (click)="onSubmitDistrictFinAchievementData()" label="{{'SUBMIT' | translate}}" class="p-button-success"
              style="width: 100px; height: 32px; align-items: center;">
          </button>
        </div>
      </div>
    </div>
  </p-panel>
</div>

<div class="mb-5">
  <p-panel header="District Other Source Achievement" [toggleable]="true" [collapsed]="true">
    
    <div class="get-district-fin-target card">
      <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Get District Other Source Achievement' |
        translate }}</p>
      <div class="p-fluid p-formgrid grid added-farmer-data justify-content-center">
        <div class="field col-12 md:col-4">
          <!-- <label></label> -->
          <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
            <button (click)="onClickDistrictOSAchieveData()" pButton pRipple label="{{ 'Get Dist. Other Source Achievement Data' | translate }}"
              class="p-button-success"></button>
          </div>
        </div>
      </div>
    
      <div *ngIf="getDistrictOSAchievementData.length == 0 && showDistrictOSAchievementDataStatus">
        <p [style]="{'color': 'red', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Data Not Found'}}</p>
      </div>
    
      <div class="dashboardTable" *ngIf="getDistrictOSAchievementData.length > 0">
        <!-- <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Added Farmer
          Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}} {{
          agreementNoToGetData?.AgreementNo }}</p> -->
        <p-table #stateTarDataTable [value]="getDistrictOSAchievementData" [rows]="10" [paginator]="true" [globalFilterFields]="[
              'I_FinancialYear_ID',
              'I_State_Code',
              'I_District_Code',
              'I_Activity_ID',
              'I_Crop_Code',
              'I_Month_ID',
              'I_FT',
              'I_PT',
              ]" [rowHover]="true" dataKey="aadharNo"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-end">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                  (input)="stateTarDataTable.filterGlobal($any($event.target).value, 'contains')"
                  placeholder="{{'SEARCH'| translate}}" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'FINANCIAL_YEAR'| translate}}</th>
              <th>{{'State Code'| translate}}</th>
              <th>{{'District Code'| translate}}</th>
              <th>{{'Activity Id'| translate}}</th>
              <th>{{'Crop Id'| translate}}</th>
              <th>{{'Month Id'| translate}}</th>
              <th>{{'PT'| translate}}</th>
              <th>{{'FT'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{product?.I_FinancialYear_ID}}</td>
              <td>{{product?.I_State_Code}}</td>
              <td>{{product?.I_District_Code}}</td>
              <td>{{product?.I_Activity_ID}}</td>
              <td>{{product?.I_Crop_Code}}</td>
              <td>{{product?.I_Month_ID}}</td>
              <td>{{product?.I_FT}}</td>
              <td>{{product?.I_PT}}</td>
            </tr>
          </ng-template>
        </p-table>
    
        <div *ngIf="getDistrictOSAchievementData.length > 0" class="button-container-submit">
          <button pButton pRipple (click)="onSubmitDistrictOSAchievementData()" label="{{'SUBMIT' | translate}}" class="p-button-success"
              style="width: 100px; height: 32px; align-items: center;">
          </button>
        </div>
      </div>
    </div>
  </p-panel>
</div>